import React, { Component } from "react";
import { Redirect } from "react-router";

import DropList from "@atlaskit/droplist";

import Search from "../SearchMap/Search";

import { SearchParams, MakeSearchUrl } from "../../utils/consts";

import "./searchBox.css";

const initState = {
  minexpense: 2000,
  maxexpense: 3000
};
export default class SearchBox extends Component {
  constructor(props) {
    super(props);

    this.state = initState;
  }

  search = () => {
    console.log("clicked");
    // const
    const url = `test`;
    return <Redirect to={`/?${url}`} />;
  };

  handleFilter = (i, item, newSelection) =>
    this.setState({ [`${item}`]: !newSelection ? i : null });

  handleLink = () => {
    const params = Object.keys(this.state)
      .filter(key => Object.keys(SearchParams)[key] !== -1)
      .filter(key => !!this.state[key]);
    let url = `?`;
    params.forEach(key => {
      url = url + `${key}=${this.state[key]}`;
    });
    console.log(params);
    console.log(url);
    return url;
  };

  search = () => this.setState({ open: false });

  render() {
    const url = "/?" + MakeSearchUrl(this.state) + `search=true`;
    return (
      <div className="searchbox">
        <DropList
          appearance="default"
          position="bottom center"
          isTriggerNotTabbable
          onOpenChange={e => console.log(e)}
          isOpen={this.state.open}
          trigger={
            <div
              onClick={() => this.setState({ open: !this.state.open })}
              className={
                this.state.open
                  ? "search-box__input search-box__input_open"
                  : "search-box__input"
              }
            >
              Search...
            </div>
          }
        >
          <div className="searchbox-search">
            <Search
              search={this.search}
              handleFilter={this.handleFilter}
              value={this.state}
              link={url}
            />
          </div>
        </DropList>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchBox/SearchBox.js